// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleSquareFilledSvg from "@fishx/icons-svg/es/asn/GoogleSquareFilled";
import FishxIcon from '../components/FishxIcon';

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleSquareFilledSvg
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
export default React.forwardRef(GoogleSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoogleSquareFilled.js
// module id = 2904
// module chunks = 0